import { UxService } from '~/app/core/services/ux.service';
import { notificationConfig, pnTypes, putPNReqParam, TelepainService } from './../../../services/telepain/telepain.service';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PushNotificationAlertComponent } from '../../dialog/push-notification-alert/push-notification-alert.component';

@Component({
  selector: 'app-push-notification-config',
  templateUrl: './push-notification-config.component.html',
  styleUrls: ['./push-notification-config.component.css']
})
export class PushNotificationConfigComponent implements OnInit {
  @Input()
  practiceCode: string

  pnTypes = pnTypes;
  loader: boolean = false;
  notificationConfig: notificationConfig[] = []

  constructor(
    private dialog: MatDialog,
    private telepainService: TelepainService,
    private uxService: UxService

  ) { }

  ngOnInit() {
    this.getPracticeConfig();
  }

  getPracticeConfig() {
    this.loader = true
    this.telepainService.getPracticeConfig(this.practiceCode).subscribe((res) => {
      this.notificationConfig = res.items.map(item => {
        item.default_notify = item.notifications_enabled;
        if(item.pn_type == pnTypes.MULTIPLE_MONTHLY_SMA_NOTIFICATION && !item.timeunit) {
          item.timeunit = 'days'
        }
        return item
      });
      setTimeout(() => {
        this.loader = false;
      }, 500);
    }, (err) => {
      this.loader = false;
    })
  }

  toggle(ev: any, item: notificationConfig) {
    ev.source.checked = item.notifications_enabled;
    this.openDialog(item);
  }

  updateConfig(item: any) {
    if(item.default_notify == item.notifications_enabled) {
       this.putNotifyConfig(item)
    } else {
      this.openDialog(item);
    }
  }

  putNotifyConfig(item: notificationConfig) {
    this.loader = true
    const reqObj: putPNReqParam = {
      ...item,
      practiceCode: this.practiceCode
    }
    this.telepainService.putPracticeNotifyConfig(reqObj).subscribe((res) => {
      this.loader = false
      if(!res.isSuccess) {
        const msg = res.message || "Error updating configuration";
        this.uxService.showInfo(msg);
          item.notifications_enabled = item.default_notify;
      } else {
         this.uxService.showInfo('Configuration has been updated successfully.');
        item.default_notify = item.notifications_enabled;
      }
    }, () => {
      this.loader = false
      item.notifications_enabled = item.default_notify;
    })
  }

  openDialog(item: notificationConfig) {
    const dialogRef = this.dialog.open(PushNotificationAlertComponent, {
      width: '475px',
      data: {
        type: (item.pn_type == pnTypes.SURVEY_NOTIFICATION || item.pn_type == pnTypes.MONTHLY_SMA_NOTIFICATION) ? !item.default_notify : item.notifications_enabled
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'ok') {
        if(item.pn_type == pnTypes.SURVEY_NOTIFICATION || item.pn_type == pnTypes.MONTHLY_SMA_NOTIFICATION) {
          item.notifications_enabled = !item.notifications_enabled;
        }
        this.putNotifyConfig(item)
      } else {
        if(item.pn_type != pnTypes.SURVEY_NOTIFICATION && item.pn_type != pnTypes.MONTHLY_SMA_NOTIFICATION && (item.default_notify == !item.notifications_enabled))  {
          item.notifications_enabled = item.default_notify
        }
      }
    });
  }

  onKeyDown(event:any, item: notificationConfig) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    if (allowedKeys.includes(event.key)) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    const updatedValue = Number(event.target.value + event.key)

    if(item.pn_type == pnTypes.MULTIPLE_MONTHLY_SMA_NOTIFICATION) {
      if (updatedValue < 1 || updatedValue > 10) {
        event.preventDefault();
      }
    }
  }
}
